import classnames from 'classnames/bind'

// Components
import ProductCard from '../ProductCard'

// Constants
import { ProductListData } from '@/hooks/useLiveRoomProduct'

// Styles
import styles from './style.module.scss'

const cx = classnames.bind(styles)

export type ProductListProps = {
  productList: ProductListData[]
  bgColor?: 'white' | 'grey'
  discountTagLayout?: 'block' | 'inline'
  showVisibilityMask?: boolean
}

const ProductList = ({ productList, bgColor = 'white', discountTagLayout = 'block', showVisibilityMask = false }: ProductListProps) => {
  return (
    <div className={cx('preview__product-list', `bg-${bgColor}`)}>
      {productList.map((productData, index) => (
        <ProductCard
          {...productData.productInfo}
          key={index}
          bgColor={bgColor}
          isMiniWidth
          discountTagLayout={discountTagLayout}
          showVisibilityMask={showVisibilityMask}
          isLive={productData.isLive}
        />
      ))}
    </div>
  )
}

export default ProductList
